/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tokens_EmptyInputs */

const cs_import_tokens_empty = /** @type {(inputs: Import_Tokens_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné aktivní tokeny.`)
};

const en_import_tokens_empty = /** @type {(inputs: Import_Tokens_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active tokens.`)
};

/**
* | output |
* | --- |
* | "No active tokens." |
*
* @param {Import_Tokens_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tokens_empty = /** @type {((inputs?: Import_Tokens_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tokens_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tokens_empty(inputs)
	return cs_import_tokens_empty(inputs)
});